import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";

const QuickSearch = () => {
  return (
    <div className="bg-foreground/10 rounded-lg p-4 flex flex-col gap-2">
      <p className="uppercase text-foreground/50 font-medium text-sm">
        Snel zoeken
      </p>
      <Input
        placeholder="Zoek naar spelers, teams, competities..."
        startContent={<Search className="w-4 h-4" />}
      />

      <div className="flex items-center gap-1">
        <Select>
          <SelectTrigger>
            <SelectValue placeholder="Sorteer" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="name">Naam</SelectItem>
            <SelectItem value="team">Team</SelectItem>
          </SelectContent>
        </Select>
        <Select>
          <SelectTrigger>
            <SelectValue placeholder="Type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="keeper">Keeper</SelectItem>
            <SelectItem value="verdediger">Verdediger</SelectItem>
            <SelectItem value="aanvaller">Aanvaller</SelectItem>
            <SelectItem value="middenvelder">Middenvelder</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-medium text-foreground/50 mt-4">Spelers</p>
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            <div className="size-8 aspect-square rounded-full bg-foreground/10">
                <img src="https://img.a.transfermarkt.technology/portrait/header/50219-1705413908.jpg?lm=1" alt="Player" className="w-full h-full rounded-full object-cover" />
            </div>
            <div className="flex flex-col w-full">
              <p className="text-sm">Simon Mignolet</p>
              <p className="text-xs text-foreground/50">Keeper · Club Brugge</p>
            </div>
          </div>
          {Array(3)
            .fill("")
            .map((_, i) => (
              <div className="flex items-center gap-3" key={i}>
                <div className="size-8 aspect-square rounded-full bg-foreground/10"></div>
                <div className="flex flex-col gap-1 w-full">
                  <div className="h-4 w-1/3 bg-foreground/10 rounded-full"></div>
                  <div className="h-3 w-1/2 bg-foreground/10 rounded-full"></div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-medium text-foreground/50 mt-4">Clubs</p>
        <div className="flex flex-col gap-4">
          {Array(2)
            .fill("")
            .map((_, i) => (
              <div className="flex items-center gap-3" key={i}>
                <div className="size-8 aspect-square rounded-full bg-foreground/10"></div>
                <div className="flex flex-col gap-1 w-full">
                  <div className="h-4 w-1/3 bg-foreground/10 rounded-full"></div>
                  <div className="h-3 w-1/2 bg-foreground/10 rounded-full"></div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default QuickSearch;
